import { render, staticRenderFns } from "./scoreTable.vue?vue&type=template&id=29a8c55b&scoped=true"
import script from "./scoreTable.vue?vue&type=script&lang=js"
export * from "./scoreTable.vue?vue&type=script&lang=js"
import style0 from "./scoreTable.vue?vue&type=style&index=0&id=29a8c55b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a8c55b",
  null
  
)

export default component.exports